import styled from 'styled-components';
import { bookitColors } from 'styles/colors/bookitColors';

export const TabsWrapper = styled('div')(({ theme }) => ({
  '&.tabsWrapper': {
    display: 'flex',
    padding: '0px 32px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    gap: '32px',
    width: '100%',
    '&.scrollContent': {
      overflow: 'hidden',
    },
    '&.tabsHorizontal': {
      '& .basicTabs': {
        flexGrow: 1,
        width: '100%',
        borderBottom: `1px solid ${bookitColors.grayscale.grayBorders}`,
      },
    },
    '&.tabsVertical': {
      flexDirection: 'row',
      padding: '0px',
    },
    '& .basicTabs': {
      backgroundColor: 'transparent',
    },
  },
}));
export const TabPanelWrapper = styled('div')(({ theme }) => ({
  '&.tabPanel': {
    width: '100%',
    '&.scrollablePanel': {
      height: '100%',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-thumb': {
        boxShadow: `inset 0 0 2px ${bookitColors.grayscale.grayBorders}`,
        borderRadius: '4px',
        backgroundColor: bookitColors.grayscale.grayBorders,
      },
    },
  },
}));
